export default __webpack_public_path__ + "static/media/logo_small.4ca11e54.svg";